// extracted by mini-css-extract-plugin
export default {"blockHeading":"style_blockHeading__SPyea","smallHeading":"style_smallHeading__cWgDW","rowHover":"style_rowHover__Ag0XB","active":"style_active__-vT-L"};